export const ELEVENLABS_CONFIG = {
  BASE_URL: "https://api.elevenlabs.io/v1/convai",
  API_KEY: "sk_8ab661ea6e03a5ee55b557c5e2768c78eb1230dcf894bd42",
  HEADERS: {
    "xi-api-key": process.env.REACT_SK_API_KEY,
    "Content-Type": "application/json",
  },
  AGENT_PHONE_NUMBER_ID: "phnum_7401k5dhsdnqesvartpzgmc7c1s4",
};

export const getElevenLabsHeaders = () => ({
  "xi-api-key": ELEVENLABS_CONFIG.API_KEY,
  "Content-Type": "application/json",
});
